<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="area-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-area"></div>
                    <div class="area-view">
                        <div class="area-box" :class="{'list-show' : listShow}">
                        <p class="now" @click="listShow = !listShow"><span>绑定大区：</span>{{ now.name }}<em class="select"></em></p>
                            <div class="area-list" v-if="listShow">
                            <vuescroll :ops="ops">
                                <ul>
                                    <li v-for="area in areas[account_type]"
                                    :key = "area.id"
                                    v-bind:data-aid="area.id"
                                    v-bind:data-name="area.name"
                                    @click="queryPlayer" v-html="area.name"></li>
                                </ul> 
                            </vuescroll>                       
                       </div>
                        </div>
                        <div class="player-name"><p><span>角色昵称：</span>{{ now.playerName }}</p></div>
                    </div>
                    <!-- <p class="warn"><em class="icon i-warn"></em>绑定大区后不可修改！请仔细核对参与角色。</p> -->
                    <div class="u-btn submit" @click="bindArea"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'area-modal',
    data : function (){
        return {
            listShow: false,
            now: {
                "id": 0,
                "name": "",
                "playerName": '',
            },
            areas: {
                    pc: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    }],
                    wg: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    },{
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    }],
                    steam: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    },{
                        "id": 21,
                        "name": "长生殿(Steam)"
                    },
                    ],                
                    test: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    },{
                        "id": 21,
                        "name": "长生殿(Steam)"
                    },{
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 100,
                        "name": "TEST_1"
                    }, {
                        "id": 110,
                        "name": "TEST_2"
                    }],                
                },
            from : {
                '1' : 'wg',
                '2' : 'steam',
                '0' : 'pc',
            },
            visible : false,
            account_type : 'pc',
            code : '',
            ua : {},
            busy : false,
            ops: {
                rail: {
                    opacity: 0.6,
                    background : '#29465c',
                    size: '6px',
                    gutterOfSide : '0px',
                },
                bar: {
                    background: '#5793c1',
                    keepShow : true,
                    size: '6px',
                }
            },                          
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.account_type = this.from[this.$store.state.userinfo.fromType.toString()];
        document.body.style.overflow = 'hidden';
        this.account_type = process.env.NODE_ENV == 'development' ? 'test' : this.from[this.$store.state.userinfo.fromType.toString()];
        //this.account_type = 'test'
    },           
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        queryPlayer(e){
            this.listShow = false;
            var _s = e.target;
            var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');
                        
            this.$axios.get(globalThis.ajax_url_map.queryplayer, {
                params: {
                    zid : vue.now.id,
                }
            })
            .then(res => {
                vue.$toast('查询成功');
                vue.now.playerName = res.data.nickName;      
            },
            rej => {
                vue.$toast(rej.message);
                vue.now.playerName = '';
            })
            .catch(function (error) {
                console.log(error);
            });             

        },
        bindArea(e){
            var _s = e.target;
            var vue = this;

            if(this.busy)return;

            //todo inviteCode
            if(!vue.now.id)return vue.$toast('请先选择绑定大区');
            if(!vue.now.playerName)return vue.$toast('端游未创角');

            this.busy = true;

            this.$axios.post(globalThis.ajax_url_map.bind, {
                zid : vue.now.id,
            })
            .then(res => {
                //vue.$update();
                var _ua = res.data;
                _ua.nickName = vue.now.playerName;
                _ua.areaId = vue.now.id;

                //this.$update_ua(_ua);
                //vue.$update_evt();

                vue.$toast('大区绑定成功，即将刷新页面，请稍后');
               
                setTimeout(() => {
                    location.reload();
                } , 300);

                // this.busy = false;
                
                // vue.destroyElement();
                     
            },
            rej => {
                this.busy = false;
                vue.$toast(rej.message);
            })
            .catch(function (error) {
                console.log(error);
            });   
        },
    },    
}
</script>

<style lang="scss">
    .area-modal{
        width: 629px;
        height: 419px;
        background-image: url(~@/assets/images/modal/bg-modal-area.png);
        font-size: 22px;
    }


    .t-area{
        width: 516px;
        height: 55px;
        margin: 0 auto 0;
        background-image: url(~@/assets/images/modal/title-bind.png);
    }

    .area-view{
        margin-top: 5px;
    }

    .area-view .area-box {
        position: relative;
        width: 540px;
        height: 85px;
        line-height: 85px;
        margin: 0 auto 0;
        box-sizing: border-box;
        color: #49392e; 
        vertical-align: middle;
        border: 2px solid #b4c5d5;
        border-radius: 10px;
        z-index: 10;
    }

    .area-view .area-box.list-show{
        background-color: #faf2dc;
    }

    .area-box p {
        position: relative;
        padding-left: 36px;
        line-height: 85px;
    }

    .area-box .now .select {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 37px;
        width: 19px;
        height: 100%;
        transform: translateY(-50%);
    }

    .area-box .now .select::after{
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/modal/icon-select.png);
        background-size: 24px 16px;
        background-position: center;
        background-repeat: no-repeat;
    }  

    .area-box .now span {
        padding-right: 42px;
        color: #49392e; 
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 76px;
        left: 50%;
        width: 540px;
        max-height: 500px;
        padding: 5px 27px 0 27px;
        background-color: #faf2dc;
        z-index: 50;
        box-sizing: border-box;
        transform: translateX(-50%);
        color: #49392e; 
        border: 2px solid #b4c5d5;
        border-top: none;
        border-radius: 0 0 10px 10px;
    }

    .area-view .area-list ul{
        display: flex;
        /* justify-content: space-between; */
        flex-wrap: wrap;
    }

    .area-view .area-list li {
        /* display: inline-block; */
        width: 50%;
        line-height: 40px;
        margin-bottom: 12px;
        text-align: center;
        box-sizing: content-box;
        border-radius: 8px;
        cursor: pointer;

        /* border-bottom: 1px dashed #e3e3e3; */
        &:hover{
            color: #fff;
            background-color: #71aeab;
        }
    }

    .area-view .player-name {
        position: relative;
        width: 540px;
        height: 85px;
        line-height: 85px;
        margin: 15px auto 0;
        box-sizing: border-box;
        // background-color: #f9eecf;
        color: #49392e; 
        vertical-align: middle;
        border: 2px solid #b4c5d5;
        border-radius: 10px;
    }

    .area-view .player-name p{
        
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: 36px;
        padding-right: 42px;
        color: #49392e; 
    }


    .area-modal .u-btn.submit{
        position: absolute;
        left: 50%;
        bottom: 25px;
        transform: translateX(-50%);
        width: 239px;
        height: 84px;
        background-image: url(~@/assets/images/modal/btn-submit.png);
        
    }
    
    .area-modal .warn{
        margin-top: 20px;
        line-height: 1.6;
        color: #bd4a4a;
        text-align: center;  
        font-size: 20px;    
    }

    .i-warn{
        display: inline-block;
        width: 17px;
        height: 18px;
        margin-right: 15px;
        background-image: url(~@/assets/images/modal/icon-warn.png);
        vertical-align: middle; 
    }
</style>



// WEBPACK FOOTER //
// src/components/AreaBind/areaModal.vue